import { readActiveFundContext } from '@/lib/auth/activeFundContext';
import { getStoredActiveFundId } from '@/lib/auth/session';
import { DEMO_TEMPLATE_EDIT_HEADER } from '@altsui/shared';
import { useTemplateEditStore } from '@/stores/templateEditStore';

export function resolveRequestFundId(): string | null {
  const context = readActiveFundContext();
  if (context.hasSession) return context.fundId;
  return getStoredActiveFundId();
}

export function buildAuthHeaders(
  includeContentType = true,
  extraHeaders: Record<string, string> = {},
): Record<string, string> {
  const fundId = resolveRequestFundId();
  // A demo template takes writes only while its manager has Edit the template on, for that template.
  const editing = fundId && useTemplateEditStore.getState().editing === fundId;
  return {
    ...(includeContentType ? { 'Content-Type': 'application/json' } : {}),
    ...(fundId ? { 'x-fund-id': fundId } : {}),
    ...(editing ? { [DEMO_TEMPLATE_EDIT_HEADER]: fundId } : {}),
    ...extraHeaders,
  };
}
